<div class="dashboard">
  <div class="grid">
    
    <div class="tile"> Placeholder</div>
    <div class="tile">
      <dx-chart id="chart" [dataSource]="customerStatistics">
        <dxo-title text="{{ 'Statistik' | translate }}">
          <dxo-subtitle text="{{ loginService.currentCustomer?.name }}"></dxo-subtitle>
        </dxo-title>
        <dxi-series valueField="skuCount" name="{{ 'Eindeutige Produkte' | translate }}"></dxi-series>
        <dxi-series *ngIf="loginService.isAdmin" valueField="eanCount" name="{{ 'Eindeutige EAN-Nummern' | translate }}"></dxi-series>
        <dxi-series valueField="fileCount" name="{{ 'Anzahl Medien' | translate }}"></dxi-series>
        <dxi-series valueField="sumFileSize" name="{{ 'Mediengröße in MB' | translate }}"></dxi-series>
        <dxo-common-series-settings argumentField="date" type="spline" hoverMode="includePoints">
          <dxo-point hoverMode="allArgumentPoints"></dxo-point>
        </dxo-common-series-settings>
        <dxo-tooltip [enabled]="true" [customizeTooltip]="customizeTooltip"></dxo-tooltip>
        <dxo-argument-axis [workdaysOnly]="true" argumentType="datetime">
          <dxo-label wordWrap="none" format="dd.MM.yy" [overlappingBehavior]="'hide'"></dxo-label>
        </dxo-argument-axis>
        <dxo-legend verticalAlignment="bottom" horizontalAlignment="center" itemTextPosition="bottom"></dxo-legend>
      </dx-chart>
    </div>

    <div class="tile"> Placeholder</div>

    <div class="tile tile--jobs">
      <div class="joblist-container">
        <div class="joblist-header">
          <h3>{{ 'Hintergrund Jobs' | translate }}</h3>
          <div class="joblist-actions"></div>
        </div>
        <job-list
          class="joblist-content"
          [storeName]="'JobListState_Dashboard_V1'"
          [jobListMode]="false"
          [catalogMode]="true"
          [adminMode]="loginService.isAdmin">
        </job-list>
      </div>
    </div>
  </div>
</div>
